import React from 'react'

// Muestra el mapper de un formatter de subida: columna del fichero → variable.
const FormatterMapper = ({ formatter, compact = false }) => {
  if (!formatter) return null
  return (
    <div className="text-left">
      {!compact && (
        <div className="mb-2">
          <p className="text-sm font-medium text-gray-900">
            Formato: {formatter.label}
            <span className="ml-2 text-xs font-normal text-gray-500">
              ({formatter.accepts.map((a) => `.${a}`).join(', ')})
            </span>
          </p>
          <p className="mt-1 text-xs text-gray-500">{formatter.description}</p>
        </div>
      )}
      <div className="overflow-hidden rounded-md border border-gray-200">
        <table className="min-w-full text-xs">
          <thead className="bg-gray-50 text-gray-700">
            <tr>
              <th className="px-3 py-1.5 text-left font-semibold">Columna del fichero</th>
              <th className="px-3 py-1.5 text-left font-semibold">Variable</th>
              <th className="px-3 py-1.5 text-left font-semibold">Nota</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 bg-white">
            {formatter.columns.map((c) => (
              <tr key={c.source}>
                <td className="px-3 py-1.5 font-mono text-gray-900">
                  {c.source}
                  {c.required && <span className="ml-1 text-red-500">*</span>}
                </td>
                <td className="px-3 py-1.5 font-mono">
                  {c.target ? (
                    <span className="text-indigo-700">{`{${c.target}}`}</span>
                  ) : (
                    <span className="text-gray-400">—</span>
                  )}
                </td>
                <td className="px-3 py-1.5 text-gray-500">{c.note || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {formatter.sample && !compact && (
        <div className="mt-3 p-3 rounded-md border border-gray-300 bg-gray-50 font-mono text-xs overflow-x-auto whitespace-pre">
          {formatter.sample.join('\n')}
        </div>
      )}
    </div>
  )
}

export default FormatterMapper
